'use client';

import { V4ErrorShell } from '@/components/marketing/route-states/V4ErrorShell';

export default function TermsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <V4ErrorShell pillar="paper" error={error} reset={reset} />;
}
